define('model/reverseGeocode/reverseGeocode',['../selector'], function (selector) {
    "use strict";
    return function (json) {
        return selector(json, "addresses");
    };
});
